import React, { Component } from 'react'
import { Upload, Modal } from 'antd'
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import ImageCropper from '../../ImageCropper'
import { parseImageFileToBase64 } from '../../../helpers/image-base64.parser' 

type ImageUploadProps = {
  name: string,
  className?: string,
  fileList?: any,
  aspect?: number,
  accept?: string,
  onChange?: (fileList: any) => void
}

export default class ImageUpload extends Component<ImageUploadProps> {

  state = {
    previewVisible: false,
    previewImage: '',
    fileList: this.props.fileList || []
  }

  componentDidUpdate(prevProps: ImageUploadProps, prevState: any) {
    const { onChange } = this.props

    if (this.state.fileList !== prevState.fileList) {
      if (onChange) {
        onChange(this.state.fileList)
      }
    }
  }

  handleLogoUpload = (file: any, fileList: any) => {
    return false
  }

  handleImageEdit = async (file: any) => {
    if (!file.url && !file.preview) {
      file.preview = await parseImageFileToBase64(file)
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true
    })

    return false
  }

  handleImageChange = async ({ file, fileList }) => {
    if (file.status === 'removed') {
      const { fileList } = this.state

      this.setState({
        fileList: fileList.filter(p => p.uid !== file.uid)
      })
    } else {
      const fileBase64 = await parseImageFileToBase64(file)
  
      this.setState({
        fileList: [
          {
            uid: fileList[0].uid,
            url: fileBase64,
            status: 'done'
          }
        ]
      })
    }
  }

  handleImageCropCancel = () => {
    this.setState({
      previewImage: '',
      previewVisible: false
    })
  }

  handleImageCropFinish = (imageBase64) => {
    const { fileList } = this.state

    this.setState({
      previewImage: '',
      previewVisible: false,
      fileList: [
        {
          uid: fileList[0].uid,
          url: imageBase64,
          status: 'done'
        }
      ]
    })
  }

  _renderUploadButton = () => {
    return (
      <div>
         <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    )
  }

  render() {
    const { name, aspect, className,accept } = this.props
    const { fileList, previewVisible, previewImage } = this.state

    return (
      <div>
        <Upload
          name={name}
          listType="picture-card"
          accept={ accept ? accept : "image/*"}
          className={className || ''}
          fileList={fileList}
          showUploadList={{
            showPreviewIcon: false,
            showDownloadIcon: true,
            showRemoveIcon: true,
            downloadIcon: <EditOutlined style={{fontSize: 32, color: '#ffffff'}} />,
            removeIcon: <DeleteOutlined style={{fontSize: 32, color: '#ffffff'}} />
          }}
          beforeUpload={this.handleLogoUpload}
          onChange={this.handleImageChange}
          onDownload={this.handleImageEdit}
        >
          {
            fileList.length > 0 ? null : this._renderUploadButton()
          }
        </Upload>

        {
          // Render edit image modal
          previewVisible && previewImage ? (
            <Modal
              title="Edit Image"
              visible={previewVisible}
              width={800}
              bodyStyle={{height: 490}}
              footer={null}
              centered={false}
              destroyOnClose={true}
              onCancel={this.handleImageCropCancel}
            >
              <ImageCropper
                src={previewImage}
                zoom={1}
                aspect={aspect || 16 / 9}
                onFinish={this.handleImageCropFinish}
                onCancel={this.handleImageCropCancel}
              />
            </Modal>
          ) : null
        }
      </div>
    )
  }
}
